import React from "react";
import { Card, Col, Placeholder, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const styles = {
  galleryCard: {
    border: "none",
    height: "300px",
    width: "100%",
    overflow: "hidden",
  },

  galleryImg: {
    height: "70%",
    objectFit: "cover",
    width: "100%",
    borderRadius: "8px",
  },

  galleryBody: {
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "30%",
  },
};

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

const EventGalleryList = ({ data }) => {
  return (
    <>
      <Row className="mb-4">
        {data.length > 0 &&
          data.map((item) => (
            <Col
              key={item._id}
              lg={4}
              className="d-flex align-items-center justify-content-center"
            >
              <Card style={styles.galleryCard}>
                <Card.Img
                  variant="top"
                  style={styles.galleryImg}
                  src={`${IMAGE_BASEURL}${item?.cover_image_path}`}
                />
                <Card.Body style={styles.galleryBody}>
                  <Card.Title className="text-center fw-bold">
                    {item?.title}
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
      </Row>
    </>
  );
};

export default EventGalleryList;
